import {Button, message, Modal, Result} from "antd"
import {DeleteOutlined} from "@ant-design/icons"
import {deleteGroupon} from "../../../api/groupon"
import React, {useState} from "react"
import {useGroupBuyingContext} from "../store/useGroupBuyingContext"

const GroupBuyingDelete = ({grouponId}) => {
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const {grouponSettingState, grouponListState} = useGroupBuyingContext()

    const handleRemoveGroupon = async () => {
        setIsLoading(true)
        await deleteGroupon([grouponId]).then(res => {
            if (res.status !== 1) {
                message.error(`删除失败：${res.detail}`)
            } else {
                message.success('删除成功')
            }
        }).catch(err => {
            message.error(`删除失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
            grouponSettingState.reFetch()
            grouponListState.reFetch()
        })
    }

    return (
        <div>
            <Button
                danger
                type={"primary"}
                icon={<DeleteOutlined/>}
                onClick={() => {
                    setIsShow(true)
                }}
            >
                删除
            </Button>
            <Modal
                open={isShow}
                onCancel={() => {
                    setIsShow(false)
                }}
                onOk={handleRemoveGroupon}
                confirmLoading={isLoading}
            >
                <Result title={"确定要删除当前团购吗"} status={"warning"}/>
            </Modal>
        </div>
    )
}

export default GroupBuyingDelete


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingDelete.js